import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { LoggedInUser, LoggedInUserService } from './logged.in.user';
import { PermissionType } from './permission';
import { Subscription } from 'rxjs';

@Directive({ selector: '[ifAuthorized]' })
export class IfAuthorizedDirective implements OnInit {
    currentProfileSub: Subscription;
    private user: LoggedInUser;

    constructor(loggedInUserService: LoggedInUserService, private elementRef: ElementRef) {
        this.user = loggedInUserService.getCurrentUser();

        if (this.user) {
            if (this.currentProfileSub) this.currentProfileSub.unsubscribe();
            this.currentProfileSub = this.user.currentProfile.subscribe(() => {
                //Update if profile is changed
                this.checkAuthorized();
            });
        }
    }

    @Input('ifAuthorized') value: string;

    @Input() read: string;
    @Input() add: string;
    @Input() edit: string;
    @Input() delete: string;

    ngOnInit() {
        this.checkAuthorized();
    }

    private ifAuthorizedForPermissionType(values: string, type: PermissionType) {
        const entities = values.split('|');

        if (entities.every(entity => {
            if (entity.indexOf('!') === -1) {
                return !this.user.canEntity(entity, type);
            } else {
                var name = entity.replace('!', '');
                return this.user.canEntity(name, type);
            }
        })) {
            return false;
        }

        return true;
    }

    private ifAuthorizedAdHoc(value: string) {
        const values = value.split('|');

        return values.some(permission => {
            if (permission.indexOf('!') === -1) {
                return this.user.canAdHoc(permission);
            } else {
                var name = permission.replace('!', '');
                return !this.user.canAdHoc(name);
            }
        });
    }

    private ifAuthorized() {
        //if no user logged in
        if (!this.user) {
            return false;
        }

        //If authorized with adhoc permission
        if (this.value) {
            //Try ad-hoc first (ad-hoc if they did 'ifAuthorized="farmTrader"')
            return this.ifAuthorizedAdHoc(this.value);
        } else {
            //Otherwise do the entity permission checks
            if (this.read && !this.ifAuthorizedForPermissionType(this.read, PermissionType.Read)) {
                return false;
            }

            if (this.add && !this.ifAuthorizedForPermissionType(this.add, PermissionType.Add)) {
                return false;
            }

            if (this.edit && !this.ifAuthorizedForPermissionType(this.edit, PermissionType.Edit)) {
                return false;
            }

            if (this.delete && !this.ifAuthorizedForPermissionType(this.delete, PermissionType.Delete)) {
                return false;
            }

            return true;
        }
    }

    private checkAuthorized() {
        if (this.elementRef.nativeElement && this.elementRef.nativeElement.style) {
            this.elementRef.nativeElement.style.display = !this.ifAuthorized() ? 'none' : '';
        }
    }

}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/auth/auth.directives.ts